interface Props {
  /** What failed to load, completing "We couldn't load …". */
  subject: string;
}

/**
 * Said out loud, because the alternative is worse than an error.
 *
 * Without this, a failed curriculum read is indistinguishable from a program
 * that genuinely has no Savanna content: both render the fallback
 * description, and the page tells a learner the program has no curriculum
 * when in fact the request failed.
 */
export const CurriculumError = ({ subject }: Props) => (
  <div className="rounded-xl border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
    We couldn&apos;t load {subject} just now. Refresh the page to try again.
  </div>
);
